import { Component, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { ESRI } from '../../../../esri-loader-util';
import { LineStyleOptions, LineStyleOptionsForArcServer, LineStyleOptionsWithNull } from '../../../../selectionOptions';
import { LayerService } from '../../../../services/layer.service';
import { LineStyle } from '../../../../types';
import { BaseSymbolEditorComponent } from '../baseSymbolEditor';

let Color: __esri.ColorConstructor;

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-line-symbol-editor-ng',
    templateUrl: './line-symbol-editor.component.html',
    styleUrls: ['../../../sharedStyles/base.scss', './line-symbol-editor.component.scss']
})
export class LineSymbolEditorComponent extends BaseSymbolEditorComponent implements OnInit {
    constructor(_vcr: ViewContainerRef, protected readonly layerService: LayerService) { super(_vcr, layerService); }

    lineSymbol: __esri.SimpleLineSymbol;
    lineStyle: LineStyle;
    lineWidth: number;

    lineStyleOptions = LineStyleOptions;

    async ngOnInit() {
        Color = await ESRI.Color;
    }

    @Input() set layerType(val: string) {
        if (val === 'map-image' || val === 'dynamic') {
            this.lineStyleOptions = LineStyleOptionsForArcServer;
        } else {
            this.lineStyleOptions = LineStyleOptionsWithNull;
        }
    }

    bindForm() {
        if (this.layerSymbol) {
            this.lineSymbol = this.layerSymbol as __esri.SimpleLineSymbol;
            this.lineStyle = this.lineSymbol.style;
            this.lineWidth = this.lineSymbol.width;
            this.symbolColor = `rgba(${this.lineSymbol.color.toRgba().join(', ')})`;
            this.originalColor = this.symbolColor;
        }
    }

    @Input()
    public applyChange = () => {
        this.lineSymbol.color = Color.fromRgb(this.symbolColor);
        this.lineSymbol.width = this.lineWidth;
        this.lineSymbol.style = this.lineStyle;
        window.dispatchEvent(new CustomEvent<string>('symbolChange', { detail: this.uniqueLayerId }));
    }
}
